<template lang="pug">
  .application
    .time
    .shift-name
      strong {{ application.shift.real_start | moment('HH:mm') }} -&nbsp;
      strong.type {{ application.shift.shift_type }}
    .comments(v-if="application.shift.comments")
      | {{ application.shift.comments }}
    .answer
      .columns.is-mobile
        .column
          a.button(:class="classNA", @click="applicationResponse('not_available')")
            span.icon
              i.fa.fa-thumbs-down
            br
            span Nein
        .column
          a.button(:class="classYes", @click="applicationResponse('yes')")
            span.icon
              i.fa.fa-meh-o
            br
            span Okay
        .column
          a.button(:class="classAbs", @click="applicationResponse('absolutely')")
            span.icon
              i.fa.fa-thumbs-up
            br
            span Ja
</template>

<script>
export default {
  name: 'application',
  props: ['application'],
  data () {
    return {}
  },
  methods: {
    applicationResponse: function (response) {
      let url = '/shift-preference/' + this.application.shift.id + '/0/' + response
      let app = this
      this.$http.get(url)
          .set({Authorization: 'jwt ' + this.$root.$refs.app.loginToken})
          .then(res => {
            this.application.answer = response
          })
          .catch((err, data) => {
            app.$notify.danger({content: err.response.body.message})
          })
    },
    checkAnswer: function (answer, classToReturn) {
      if (this.application.answer === '') {
        return classToReturn
      } else {
        if (this.application.answer === answer) {
          return classToReturn
        }
      }
    }
  },
  created () {
  },
  computed: {
    classAbs: function () { return this.checkAnswer('absolutely', 'is-success') },
    classYes: function () { return this.checkAnswer('yes', 'is-success') },
    classNo: function () { return this.checkAnswer('no', 'is-warning') },
    classNA: function () { return this.checkAnswer('not_available', 'is-danger') }
  }
}
</script>


<style scoped lang="sass">

.application
  margin-top: 1em

.time, .shift-name
  font-size: 14px

.shift-name .type
  color: cornflowerblue

.column
  padding: 12px 1px

.answer
  .column
    text-align: center
  .button

    display: inline-block
    height: 50px
    width: 85px
    padding: 3px 0
    span
      margin: 0

.comments
  margin: 1em 0

</style>



// WEBPACK FOOTER //
// Application.vue?7cd79d09